import { RegisterOptions, useFormContext } from 'react-hook-form';

export interface FormRadioItem {
  label: string;
  value: string | number;
}

export interface FormRadioProps {
  name: string;
  // eslint-disable-next-line react/require-default-props
  options?: RegisterOptions;
  items: FormRadioItem[];
}

function FormRadio(props: FormRadioProps) {
  const formContext = useFormContext();
  const { name, options } = props;

  return (
    <>
      {props.items.map((item, index) => (
        <div key={`radio_${name}_${index}`} className="ct_form-row">
          <div className="ct_form-col">
            <div className="ct_form-group">
              <div className="ct_form-control">
                <input
                  className="ct_radio"
                  id={`radio_${name}_${index}`}
                  type="radio"
                  {...formContext.register(name, options)}
                  value={item.value}
                />
                <label htmlFor={`radio_${name}_${index}`}>{item.label}</label>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default FormRadio;
